import './Progress.scss';

interface Props {
  value: number;
  max: number;
  className?: string;
  getProgressBarColor?: (v: number) => string;
  labelStart?: string;
  labelEnd?: string;
}

const Progress = ({
  value,
  max,
  className = '',
  labelStart,
  labelEnd,
  getProgressBarColor,
}: Props) => {
  const width = Math.round(((value * 1000) / (max * 1000)) * 100);

  const getColor = () => {
    if (width >= 70 && width < 100) {
      return '#ff7800';
    }
    if (width >= 100) {
      return '#264f3f';
    }
    return '#0da86b';
  };

  return (
    <div>
      {(labelStart || labelEnd) && (
        <div className='d-flex justify-content-between mb-2'>
          {labelStart && (
            <div className='Text--xs text-uppercase'>{labelStart}</div>
          )}
          {labelEnd && (
            <div className='Text--xs text-uppercase'>{labelStart}</div>
          )}
        </div>
      )}
      <div
        className={`Progress position-relative overflow-hidden ${className}`}
      >
        <div
          className='Progress__bar position-absolute'
          style={{
            width: `${width > 100 ? 100 : width}%`,
            backgroundColor: getProgressBarColor
              ? getProgressBarColor(width)
              : getColor(),
          }}
        />
      </div>
    </div>
  );
};

export default Progress;
